
jQuery(function($) {
    $(document).ready(function(){
        initSwiperSlider();

        /**
         * Initialize Swiper - http://idangero.us/swiper
         */
        function initSwiperSlider(){
            var mySwiper1 = new Swiper ('.swiper-container', {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                autoplay: '5500',

                // Navigation arrows
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',

                // If we need pagination
                pagination: '.swiper-pagination',
                paginationClickable: 'true',
                effect: 'fade'
            })
        }
    });
});